import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Button from '@components/common/Button';
import PlanUpgradeModal from '@components/common/PlanUpgradeModal';
import { ROUTES } from '@constants';

const PlanUpgrade = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);

  const handleClose = () => {
    setShowModal(false);
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-7xl mx-auto">
        <Button 
          variant="outline" 
          onClick={() => navigate(-1)}
          className="mb-4"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>

        <PlanUpgradeModal
          isOpen={showModal}
          onClose={handleClose}
        />
      </div>
    </div>
  );
};

export default PlanUpgrade;
